import useAppDispatch from 'hooks/shared/store/useAppDispatch';
import useAppSelector from 'hooks/shared/store/useAppSelector';
import isEmpty from 'lodash/isEmpty';
import randomColor from 'randomcolor';
import { useEffect } from 'react';
import { companiesPieColorsSelector } from 'selectors/modules/companies/companiesPieColors';
import { CompaniesPieColors, companiesPieColorsSlice } from 'slices/modules/companies/companiesPieColors';

const useUpdateCompaniesPieColors = (companies: string[]): void => {
  const dispatch = useAppDispatch();

  const pieColors = useAppSelector(companiesPieColorsSelector);

  useEffect(() => {
    if (companies) {
      const next: CompaniesPieColors = {};
      for (const company of companies) {
        if (!pieColors[company]) {
          next[company] = randomColor();
        }
      }
      if (!isEmpty(next)) {
        dispatch(companiesPieColorsSlice.actions.updatePieColors(next));
      }
    }
  }, [companies]);
};

export default useUpdateCompaniesPieColors;
